import { isoDateToString } from "../../util/format-date";
import { truncate } from "../../util/format-text";

export default function TollCard({ toll, selected, onClick }) {
  const clickHandler = () => {
    onClick && onClick(toll);
  };
  return (
    <div
      onClick={clickHandler}
      className={`grid items-center lg:grid-cols-8 gap-x-4 text-stone-200 ${
        selected ? "selected-card" : "card"
      } ${
        toll.invoiced
          ? "border-green-600"
          : toll.customer
          ? "border-yellow-600"
          : "border-red-600 animate-pulse"
      }`}
    >
      <p className="text-stone-400">
        {isoDateToString(toll.date, "MM/dd/yyyy hh:mm a")}
      </p>
      <p className="font-semibold">
        {toll.vehicle
          ? `${toll.vehicle.year} ${
              toll.vehicle.model
            } - ${toll.vehicle.vin.substring(13, 17)}`
          : `${toll.license} ${toll.state}`}
      </p>
      <p className="lg:col-span-2">
        {toll.customer
          ? `${toll.customer.firstName} ${toll.customer.lastName}`
          : "Unknown"}
      </p>
      <p className="md:col-span-2">{truncate(toll.location, 40)}</p>
      <p className="text-stone-400">{toll.agency}</p>
      <p className="font-semibold text-right">${toll.amount}</p>
    </div>
  );
}
